<template>
  <div class="mask" @tap.stop @touchstart.stop @touchend.stop @touchmove.stop>
    <div class="r_container_D" :class="[showBoxPop ? 's_container_show' : '']">
      <div class="r_box_D">
        <div class="r_box_hd_D">
          <div class="hd_tit_D">
            <div class="wx_pay_tips_D">
              <img
                src="https://fruitsoss.yunyihudong.com/shortPlay/images/v150/rechargeD/wx_pay_title.png"
              />
            </div>
            感谢您支持作者，购买后继续观看
          </div>
          <div class="hd_close_D" @click="closeRecharge">
            <img src="../../static/images/pop/icon_close_gray.png" />
          </div>
        </div>
        <div v-if="rechargeProps.from == 1" class="r_box_coin_D">
          <div class="user_coins">
            <div class="user_coins_item">
              本集价格：<span class="numberItalic">{{ rechargeProps.curCostCoins }}</span
              >{{ coinName }}
            </div>
            <div class="box_s_line" />
            <div class="user_coins_item">
              账户余额：<span class="numberItalic">{{ userInfo.all_coin }}</span
              >{{ coinName }}
            </div>
          </div>
        </div>
        <div v-if="rechargeProps.from != 1" class="r_box_coin_D">
          <div class="user_coins">
            <img class="user_coins_icon" src="../../static/images/pop/icon-coin2.png" />
            <div
              class="user_coins_item"
              :style="{ textAlign: 'left', marginRight: 'auto', marginLeft: $options.filters.px2rem(6) }"
            >
              账户余额：<span class="numberItalic"> {{ userInfo.all_coin }} </span>{{ coinName }}
            </div>
          </div>
        </div>
        <div class="r_box_bd_D">
          <div class="r_listD">
            <div class="r_listD_flex">
              <div
                v-if="excitationShow"
                class="listD_item_new_fuli"
                @click="clickItem('countDown')"
              >
                <div class="listD_item_count_down_header">
                  <div style="display: flex; align-items: center">
                    <img
                      class="listD_item_count_down_img"
                      src="https://fruitsoss.yunyihudong.com/shortPlay/images/v200/countDownTitle.png"
                    />
                  </div>
                  <div class="listD_item_count_down_time">
                    <div class="listD_item_count_down_time_content">
                      <span class="listD_item_count_down_time_min fadeIn">
                        {{ excitationTimeObj.minutes || '00' }} </span
                      >：
                      <span class="listD_item_count_down_time_second fadeIn">
                        {{ excitationTimeObj.seconds || '00' }} </span
                      >后结束
                    </div>
                  </div>
                </div>
                <div class="listD_item_new_fuli_content">
                  <div class="listD_item_new_fuli_left">
                    <div class="listD_item_new_fuli_content_price">
                      {{ excitationObj.rechargeCount }}<span>元</span>
                      <div class="listD_item_new_fuli_content_discount">
                        {{ excitationObj.tabText }}
                      </div>
                    </div>
                    <div class="listD_item_new_fuli_content_give">
                      {{ excitationObj.bottomText }}{{ coinName }}
                    </div>
                  </div>
                  <div class="listD_item_new_fuli_right">
                    {{ excitationObj.btnText }}<span class="right-triangle" />
                  </div>
                </div>
                <img
                  v-if="handSwitch == 1"
                  class="hand_img"
                  src="https://fruitsoss.yunyihudong.com/shortPlay/images/v105/headimg.png"
                  mode="scaleToFill"
                />
              </div>
              <div class="listD_item_container">
                <div
                  v-for="(item, index) in list"
                  :key="index"
                  class="listD_item"
                  @click="clickItem('coins', index)"
                >
                  <div class="listD_item_box">
                    <div class="listD_item_price numberItalic">
                      {{ item.rechargeCount }}<span>元</span>
                    </div>
                    <div v-if="item.middleText" class="listD_item_give">
                      {{ item.middleText }}
                    </div>
                    <div class="listD_item_val">{{ item.bottomText }}{{ coinName }}</div>
                    <div v-if="item.leftTopTitle" class="list_item_discount_D">
                      {{ item.leftTopTitle }}
                    </div>
                    <img
                      v-if="!excitationShow && handIndex == index && handSwitch == 1"
                      class="hand_img"
                      src="https://fruitsoss.yunyihudong.com/shortPlay/images/v105/headimg.png"
                      mode="scaleToFill"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="r_box_ft_D save_area">
          <div class="ft_card_D">
            <img
              class="ft_card_bg_D"
              src="https://fruitsoss.yunyihudong.com/shortPlay/images/v150/rechargeD/vip_container.png"
            />
            <div class="ft_card_tit_D">{{ vipObj.title }}</div>
            <div class="ft_card_txt_D">
              {{
                !isVip ? vipObj.text : `有效期至: ${formatDateDay(userInfo.vip_expire, true, true)}`
              }}
            </div>
            <div class="ft_card_btn_D" @click="clickItem('vip')">
              <img
                mode="scaleToFill"
                src="https://fruitsoss.yunyihudong.com/shortPlay/images/v150/rechargeD/vip_btn.png"
              />
              <div class="ft_card_btn_text_D">{{ !isVip ? '立即开通' : '续费' }}</div>
            </div>
            <img
              v-if="!excitationShow && handIndex == 6 && handSwitch == 1"
              class="hand_img"
              src="https://fruitsoss.yunyihudong.com/shortPlay/images/v105/headimg.png"
              mode="scaleToFill"
            />
          </div>
          <div class="ft_tips_D">
            注意：充值即代表同意<span style="color: #5589f3" @click="toAgreement">《充值协议》</span
            >，未成年人需要在监护人指导、同意下进行相关操作
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { getTemplate } from '@/apis/pay.js'
import { requestPayment } from '@/common/utils/requestPayment.js'
import { localSet } from '../../common/storage'
import { formatDateDay } from '@/common/utils'
export default {
  name: 'ZyPopRecharge',
  data() {
    return {
      templateObj: {}, // 服务端返回的模板对象
      featureName: '', // 变体名称
      isReuqestPay: false, // 是否正在支付
      showBoxPop: false, // 是否展示充值弹窗
      vipObj: {}, // vip信息
      list: [], // 支付列表
      handIndex: 0, // 小手位置
      handSwitch: 0, // 小手开关
      excitationObj: {}, // 限时充值对象
      excitationTimeObj: {}, // 限时倒计时对象
      excitationTimer: null, // 倒计时计时器
      excitationShow: true // 是否展示限时充值
      // rechargeProps: {
      //   // 充值浮层参数
      //   curCostCoins: '',
      //   scene: '非剧集触发',
      //   from: 1 // 弹窗拉起来源 1-解锁视频  2-其他来源 3-福利中心
      // }
    }
  },
  computed: {
    ...mapGetters([
      'isVip',
      'userInfo',
      'currentPage',
      'coinName',
      'rechargeProps',
      'popRechargeDCountDownTime'
    ])
  },
  // 打开该弹窗 供父组件使用 初始化特性和支付列表
  async created() {
    this.getList(true)
    console.log('rechargeProps', this.rechargeProps)
  },
  methods: {
    formatDateDay,
    setCountDown() {
      let countDown = (this.popRechargeDCountDownTime - new Date().getTime()) / 1000
      console.log('setCountDown', countDown)
      if (countDown <= 0) {
        this.excitationShow = false
        this.excitationTimer && clearInterval(this.excitationTimer)
        return
      }
      this.excitationTimer = setInterval(() => {
        this.excitationTimeObj = this.$utils.getTimeLeft(countDown)
        // console.log(this.excitationObj);
        if (countDown <= 0) {
          this.excitationShow = false
          this.excitationTimeObj = this.$options.data().excitationTimeObj
          this.excitationTimer && clearInterval(this.excitationTimer)
        } else {
          this.excitationShow = true
          countDown--
          this.$store.commit(
            'abPop/SET_POPRECHARGEDCOUNTDOWNTIME',
            this.popRechargeDCountDownTime - 1000
          )
        }
      }, 1000)
    },
    closeRecharge() {
      this.reportClick('关闭')
      this.$store.commit('abPop/SET_RECHARGEPROPS', {
        // 充值浮层参数
        curCostCoins: '',
        scene: '非剧集触发',
        from: 2 // 弹窗拉起来源 1-解锁视频  2-其他来源 3-福利中心
      })
      this.showBoxPop = !this.showBoxPop
      setTimeout(() => {
        this.$emit('close')
      }, 300)
    },
    // 跳转到充值协议
    toAgreement() {
      this.reportClick('充值协议')
      localSet({ name: 'jumpRecharge', value: true })
      this.$router.push('/Treaty')
    },
    async getList(isReport) {
      // 获取支付列表
      getTemplate()
        .then((res) => {
          console.log('[getTemplate]', res)
          const data = res.tpl
          this.featureName = res.name
          this.templateObj = JSON.parse(JSON.stringify(data))
          this.excitationObj = data.countDown
          this.list = data.coins
          this.vipObj = data.vip
          this.handSwitch = data.handSwitch
          if (data.handPosition) {
            this.handIndex =
              data.handPosition > 7 || data.handPosition <= 0 ? 0 : data.handPosition - 1
          } else {
            this.handIndex = 0
          }
          console.log('[this.handIndex]', this.handIndex)
          if (this.excitationObj.countDownTime && this.excitationObj.countDownTime > 0) {
            if (this.popRechargeDCountDownTime == 0) {
              this.excitationObj.countDownTime =
                this.excitationObj.countDownTime * 1000 + new Date().getTime()
              this.$store.commit(
                'abPop/SET_POPRECHARGEDCOUNTDOWNTIME',
                this.excitationObj.countDownTime
              )
            }
            this.setCountDown()
          } else {
            this.excitationShow = false
          }
          this.showBoxPop = true
          if (isReport) {
            REPORT_SDK.report({
              event_id: 'recharge_template_pop_show',
              event_name: '充值模板弹窗',
              referer: this.currentPage
            })
          }
        })
        .catch((err) => {
          this.$store.commit('abPop/SET_RECHARGEPROPS', {
            // 充值浮层参数
            curCostCoins: '',
            scene: '非剧集触发',
            from: 2 // 弹窗拉起来源 1-解锁视频  2-其他来源 3-福利中心
          })
          this.showBoxPop = !this.showBoxPop
          setTimeout(() => {
            this.$emit('close')
          }, 300)
        })
    },
    reportClick(e) {
      REPORT_SDK.report({
        event_name: '充值模板弹窗点击',
        event_id: 'recharge_template_pop_click',
        referer: this.currentPage,
        element_name: e
      })
    },
    // 充值
    clickItem(type, index) {
      if (type == 'vip') {
        this.reportClick('开通会员')
      } else {
        this.reportClick('充值项')
      }
      this.requestRecharge(type, index)
    },
    requestRecharge(type = 'coins', index) {
      if (this.isReuqestPay) return
      this.isReuqestPay = true
      const pay_from = this.rechargeProps.scene
      let obj = {
        rechargeType: 'normal',
        temp_index: index,
        temp_obj: this.templateObj
      }
      requestPayment(obj, type, '充值浮层', pay_from)
        .then((res) => {
          try {
            console.log('requestPayment-success', res)
            this.isReuqestPay = false
            this.$emit('paySuccess')
          } catch (error) {
            console.log('requestPayment-catch', error)
          }
        })
        .catch((err) => {
          this.isReuqestPay = false
          console.log('充值弹窗', err)
          if (err && err.data.STATUS == 1400) {
            // this.$refs.ZyToast.show({
            //   message: '网络开小差，请重试'
            // })
            this.getList()
          } else {
            this.$emit('payFail')
          }
        })
    }
  }
}
</script>
<style lang="less" scoped>
.save_area {
  padding-bottom: var(--safe-area-bottom);
}

.mask {
  position: fixed;
  top: 0px;
  left: 0px;
  width: 100vw;
  height: 100vh;
  z-index: 11;
  background-color: rgba(0, 0, 0, 0.7);
}
.r_container_D {
  position: absolute;
  width: 750px;
  bottom: 0;
  left: 0;
  transform: translateY(100%);
  opacity: 0;
  transition: all 300ms;
  .right-triangle {
    display: inline-block;
    width: 0px;
    height: 0px;
    margin-left: 10px;
    border-left: 10px solid #fff;
    border-top: 8px solid transparent;
    border-bottom: 8px solid transparent;
  }
  .wx_pay_tips_D {
    display: flex;
    justify-content: center;
    align-items: flex-end;
    margin-bottom: 14px;
    font-size: 30px;
    img {
      width: 224px;
      height: 34px;
    }
  }
  .r_box_D {
    box-sizing: border-box;
    width: 750px;
    position: relative;
    background: #fff;
    border-radius: 24px 24px 0 0;
    .r_box_coin_D {
      display: flex;
      justify-content: center;
      margin-top: 30px;
      .user_coins {
        display: flex;
        align-items: center;
        width: 690px;
        height: 62px;
        background: #f7f7f7;
        border-radius: 32px;
        .user_coins_icon {
          width: 40px;
          height: 40px;
          margin-left: 20px;
        }

        .user_coins_item {
          margin: 0 auto;
          line-height: 40px;
          height: 40px;
          font-size: 24px;
          color: #000;
          text-align: center;

          span {
            font-size: 28px;
            font-weight: 600;
          }
        }

        .box_s_line {
          width: 2px;
          background: #dedede;
          height: 38px;
        }
      }
    }

    .r_box_hd_D {
      box-sizing: border-box;
      width: 100%;
      height: 132px;
      border-bottom: 2px solid #f7f7f7;
      display: flex;
      align-items: center;
      justify-content: center;

      .hd_tit_icon_D {
        width: 30px;
        height: 30px;
        margin: 0 18px;
      }

      .hd_tit_D {
        font-size: 36px;
        color: #000;
        font-weight: 600;
        text-align: center;
      }

      .hd_close_D {
        width: 44px;
        height: 44px;
        position: absolute;
        right: 20px;
        top: 14px;

        img {
          width: 44px;
          height: 44px;
          position: absolute;
          top: 0;
          left: 0;
        }
      }
    }
    .r_box_bd_D {
      box-sizing: border-box;
      height: 760px;
      margin-bottom: 20px;
      .r_listD {
        box-sizing: border-box;
        width: 100%;
        height: 760px;
        padding-top: 30px;
        position: relative;
        overflow-y: scroll;
        .r_listD_flex {
          padding: 0 30px;
          flex-direction: column;
          display: flex;
        }
        .listD_item_new_fuli {
          width: 100%;
          height: 240px;
          display: inline-block;
          box-sizing: border-box;
          border-radius: 20px;
          background: linear-gradient(90deg, #ff4241 0%, #fd664e 100%);
          padding: 0 20px;
          margin-bottom: 20px;
          justify-content: center;
          position: relative;
          .hand_img {
            width: 109px;
            height: 128px;
            position: absolute;
            bottom: -10px;
            right: -30px;
            transform-origin: 0 0;
            // #ifdef MP-WEIXIN
            animation-name: scaleAni;
            animation-iteration-count: infinite;
            animation-duration: 400ms;
            // #endif
          }
          .listD_item_count_down_header {
            display: flex;
            justify-content: space-between;
            align-items: center;
            height: 62px;
            .listD_item_count_down_img {
              width: 256px;
              height: 40px;
            }
            .listD_item_count_down_img2 {
              position: relative;
              width: 109px;
              height: 28px;
              display: flex;
              align-items: center;
              justify-content: center;
              span {
                position: absolute;
                font-size: 22px;
                color: #fe5348;
                font-weight: 500;
              }
              img {
                width: 109px;
                height: 28px;
              }
            }
            .listD_item_count_down_time {
              height: 62px;
              display: flex;
              justify-content: center;
              align-items: center;
              font-size: 22px;
              color: #ffffff;
              font-weight: 400;
              .listD_item_count_down_time_content {
                height: 32px;
              }
              .listD_item_count_down_time_min,
              .listD_item_count_down_time_second {
                display: inline-block;
                height: 32px;
                line-height: 32px;
                padding: 0 10px;
                border-radius: 4px;
                background: #fff0f0;
                font-family: 'BoldItalic';

                color: #513114;
                font-size: 26px;
                margin-right: 12px;
              }
            }
          }
          .listD_item_new_fuli_content {
            height: 160px;
            border-radius: 20px;
            background: #fff1f1;
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 0 20px;
            .listD_item_new_fuli_left {
              display: flex;
              flex-direction: column;
              .listD_item_new_fuli_content_price {
                font-weight: bold;
                font-family: 'BoldItalic';
                color: #333333;
                font-size: 58px;
                margin-bottom: 8px;
                .listD_item_new_fuli_content_discount {
                  position: relative;
                  top: -6px;
                  color: #513114;
                  display: inline-block;
                  margin-left: 10px;
                  padding: 0 18px;
                  font-weight: bold;
                  font-size: 34px;
                  background: linear-gradient(131deg, #ffebcd 0%, #e8c781 100%);
                  line-height: 52px;
                  border-radius: 20px;
                  border-bottom-left-radius: 0px;
                  height: 52px;
                }
                span {
                  font-size: 24px;
                }
              }
              .listD_item_new_fuli_content_give {
                width: auto;
                border-radius: 200px;
                opacity: 0.5;
                font-weight: 400;
                color: rgba(0, 0, 0, 0.9);
                font-size: 24px;
                height: 44px;
              }
            }
            .listD_item_new_fuli_right {
              width: 180px;
              height: 68px;
              background: linear-gradient(148deg, #ff4141 0%, #fd664f 100%);
              color: #fff;
              font-weight: 600;
              font-size: 30px;
              display: flex;
              align-items: center;
              justify-content: center;
              border-radius: 200px;
            }
          }
        }
        .listD_item_container {
          display: flex;
          width: 100%;
          flex-wrap: wrap;
          justify-content: space-between;
        }
        .list_item_discount_D {
          padding: 0 14px;
          position: absolute;
          top: 0;
          left: 0;
          height: 44px;
          color: #fff;
          font-size: 24px;
          text-align: center;
          line-height: 44px;
          border-top-left-radius: 16px;
          border-bottom-right-radius: 16px;
          background: linear-gradient(148deg, #ff4141 0%, #fd664f 100%);
        }
        .listD_item {
          position: relative;
          display: inline-block;
          width: 334px;
          border-radius: 10px;
          box-sizing: border-box;
          background: url('https://fruitsoss.yunyihudong.com/shortPlay/images/v150/rechargeD/pay_box.png');
          background-size: cover;
          height: 222px;
          margin-left: 20px;
          margin-bottom: 20px;
          .listD_item_box {
            width: 100%;
            height: 100%;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
          }
          .listD_item_price {
            font-size: 56px;
            font-weight: bold;
            font-family: BoldItalic;
            color: #000000;
            margin-bottom: 12px;
            span {
              margin-left: 5px;
              font-size: 26px;
            }
          }
          .listD_item_give {
            height: 34px;
            font-size: 24px;
            padding: 0 12px;
            color: rgba(81, 49, 20, 1);
            border-top-left-radius: 20px;
            border-bottom-right-radius: 20px;
            background: linear-gradient(131deg, #ffebcd 0%, #e8c781 100%);
            margin-bottom: 6px;
          }
          .listD_item_val {
            color: rgba(0, 0, 0, 0.9);
            opacity: 0.5;
            font-weight: 400;
            font-size: 24px;
          }
          .hand_img {
            width: 109px;
            height: 128px;
            position: absolute;
            bottom: -76px;
            right: 5px;
            transform-origin: 0 0;
            // #ifdef MP-WEIXIN
            animation-name: scaleAni;
            animation-iteration-count: infinite;
            animation-duration: 400ms;
            // #endif
          }
        }

        .listD_item:nth-child(2n + 1) {
          margin-left: 0;
        }
      }
    }
    .r_box_ft_D {
      height: 224px;
      width: 750px;
      background: linear-gradient(131deg, #3e3e3e 0%, #494949 100%);
      display: flex;
      flex-direction: column;
      align-items: center;
      box-sizing: content-box !important;
      .ft_card_D {
        position: relative;
        margin-top: 30px;
        width: 690px;
        height: 128px;
        margin-bottom: 18px;

        .ft_card_bg_D {
          position: absolute;
          z-index: 0;
          width: 690px;
          height: 128px;
          top: 0;
          left: 0;
        }

        .ft_card_tit_D {
          position: absolute;
          font-size: 30px;
          font-weight: 600;
          color: #513114;
          left: 132px;
          top: 26px;
        }

        .ft_card_txt_D {
          position: absolute;
          left: 132px;
          top: 72px;
          font-size: 24px;
          font-weight: 400;
          color: #513114;
        }

        .ft_card_btn_D {
          position: absolute;
          right: 22px;
          top: 28px;
          width: 156px;
          height: 64px;
          // overflow: hidden;
          text-align: center;
          line-height: 64px;
          img {
            width: 156px;
            height: 64px;
          }
          .ft_card_btn_text_D {
            position: absolute;
            left: 0;
            top: 0;
            border-radius: 200px;
            width: 156px;
            height: 64px;
            z-index: 2;
            color: #513114;
            font-size: 28px;
            font-weight: 600;
            line-height: 64px;
            text-align: center;
          }
        }
        .hand_img {
          width: 109px;
          height: 128px;
          position: absolute;
          bottom: -76px;
          right: 5px;
          transform-origin: 0 0;
          // #ifdef MP-WEIXIN
          animation-name: scaleAni;
          animation-iteration-count: infinite;
          animation-duration: 400ms;
          // #endif
        }
      }

      .ft_tips_D {
        color: #fff;
        font-size: 18px;
      }
    }
  }
}
.s_container_show {
  opacity: 1;
  transform: translateY(0);
}

@keyframes btnLight {
  0% {
    opacity: 0;
  }

  15% {
    opacity: 1;
  }

  35% {
    opacity: 1;
  }

  40% {
    opacity: 0;
    transform: translateX(96px);
  }

  50% {
    opacity: 0;
    transform: translateX(96px);
  }

  100% {
    opacity: 0;
    transform: translateX(96px);
  }
}

@keyframes scaleAni {
  0% {
    transform: scale(0.9);
  }

  50% {
    transform: scale(1);
  }

  100% {
    transform: scale(0.9);
  }
}

.list_item_discount {
  border-radius: 10px 20px 20px 0;
  position: absolute;
  top: -16px;
  left: 0;
  width: 120px;
  height: 40px;
  color: #fff;
  font-size: 24px;
  text-align: center;
  line-height: 40px;
  background: linear-gradient(148deg, #ff4141 4%, #fd664f 100%);
}
</style>
